module.exports = __webpack_public_path__ + "img/helmetgif_1x.d1ec6de9.gif";